/*
 * @Descripttion:
 * @version:
 * @Author: JumpingBirds
 * @Date: 2020-08-03 13:01:54
 * @LastEditors: JumpingBirds
 * @LastEditTime: 2020-09-09 13:14:29
 */
let root = process.env.NODE_ENV //环境变量，webpack插件生成，并非原生node属性
let ipConfig = {
  "development": { //开发环境
    // serverIP: 'http://10.1.5.51:6072/hnswc-business-portal',
    adminIP: "http://10.1.5.51:6077/",

    // serverIP: 'http://222.143.32.185/hnswc-business-portal',
    // serverIP: 'http://10.1.5.42:8882/hnswc-business-portal',
    serverIP: 'http://10.1.5.72:8882/hnswc-business-portal',
    // adminIP: 'http://222.143.32.185/'
  },
  'production': { //华为云生产环境
    serverIP: 'http://10.41.7.67:8102/hnswc-business-portal',
    adminIP: 'http://10.41.7.67:8200/'
  },
  'yun': { //河南省政务专有云
    serverIP: 'https://www.henanstbc.cn/hnswc-business-portal',
    adminIP: 'https://www.henanstbc.cn/'
  },
  'testpro': { //公司68服务器测试环境
    serverIP: 'http://10.1.100.68:6072/hnswc_business_portal',
    adminIP: 'http://10.1.100.68:6077/'
  },
  'testpro172': { //公司172服务器测试环境
    serverIP: 'http://10.1.5.51:6072/hnswc-business-portal',
    adminIP: "http://10.1.5.51:6077/",
  },
  'sbz': { //水保站服务器测试环境
    serverIP: 'http://10.41.33.203:7072/hnswc_business_portal',
    adminIP: 'http://10.41.33.203:7077/'
  }
}
export default ipConfig[root]



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = null
// module chunks = 